(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.pk-quick-add');
      if (!btn || btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const label = btn.querySelector('span');
      const originalText = label.textContent;
      btn.disabled = true;
      label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          label.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('pk:cart:refresh'));
          setTimeout(() => {
            label.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        })
        .catch(() => {
          label.textContent = 'Try again';
          setTimeout(() => {
            label.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
